import React from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
// import { exportExcel } from '../ExportData/ExcelExport';

const CustomListHeader = ({ history, url, type }) => {
  return (
    <Grid container alignItems="center" justifyContent="space-between" style={{ padding: '32px 0px' }}>
      <Grid container item xs={6} style={{ gap: 16 }}>
        <Typography variant="h5" component="h1" style={{ fontWeight: 700 }}>
          {type || ''} List
        </Typography>
        {url && (
          <Button onClick={() => history.push(url || '')} variant="outlined" color="primary" size="small">
            Registration
          </Button>
        )}
      </Grid>

      {/* <Grid container justifyContent="flex-end" item xs={6}>
        <Button variant="contained" color="primary" size="small" onClick={() => exportExcel({ jsonData: data, type: type })}>
          Download All list
        </Button>
      </Grid> */}
    </Grid>
  );
};
export default CustomListHeader;
